import React, { Component } from "react";
import PropTypes from "prop-types";
import ProgressBar from "../../common/progress/ProgressBar";
import translate from "react-i18next/dist/commonjs/translate";

class SystemStatusWidgetTable extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { systemStatus, downtime, t } = this.props;
    return (
      <table className="table table-responsive">
        <tbody>
          <tr>
            <td className="text-lg text-strong no-border">
              {systemStatus.uptimePercentageLastYear}%
            </td>
            <td className="text-muted no-border">
              {t("systemStatusWidgetLast365DaysTitle")}
            </td>
          </tr>
          <tr>
            <td>
              <i
                className={`fa fa-2 ${
                  systemStatus.isSLAFullfilled
                    ? "fa-check text-success"
                    : "fa-close text-critical"
                }`}
              />
            </td>
            <td className="text-muted">
              {t("systemStatusWidgetLastMonthSLATitle")}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="2">
              <h5>{t("systemStatusWidgetLatestDowntimeTitle")}</h5>

              {systemStatus.downTimeDurationInMinutes > 0 ? (
                <p>
                  {t("systemStatusWidgetLatestDowntimeTextPartOne")}{" "}
                  {systemStatus.latestDownTime},{" "}
                  {t("systemStatusWidgetLatestDowntimeTextPartTwo")}{" "}
                  <strong>
                    {downtime.h} {t("systemStatusWidgetHours")}
                  </strong>{" "}
                  {t("systemStatusWidgetAnd")}{" "}
                  <strong>
                    {downtime.m} {t("systemStatusWidgetMinutes")}
                  </strong>
                  .
                </p>
              ) : (
                <p>{t("systemStatusWidgetDowntime")}.</p>
              )}
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <h5>{t("systemStatusWidgetUsedLogSpaceTitle")}</h5>
              <ProgressBar
                value={systemStatus.usedLogSpace}
                maxValue={systemStatus.totalThresholdGb}
                showWarning={systemStatus.isLowLogSpace}
              />
              <p className="text-muted">
                {systemStatus.freeLogSpace.toFixed(0)}
                {t("systemStatusWidgetGB")}{" "}
                {t("systemStatusWidgetUsedLogSpaceFreeOf")}{" "}
                {systemStatus.totalThresholdGb.toFixed()}
                {t("systemStatusWidgetGB")}
              </p>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }
}

SystemStatusWidgetTable.propTypes = {
  systemStatus: PropTypes.object.isRequired,
  downtime: PropTypes.object.isRequired
};

export default translate("translations")(SystemStatusWidgetTable);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/SystemStatusWidgetTable.js